<template>
  <div class="listmain ">
      <h1 class="firTitle">OVSMediaCodec 使用</h1>
      <span>

<p class="ql-long-7802039">
	<span class="ql-author-7802039 ql-size-9">导入 OVSMediaCodec.framework</span>
</p>

<p class="ql-long-7802039">
	<strong class="ql-author-7802039 ql-size-9">使用下载过的文件，如：opus文件 转换成 wav文件</strong>
</p>

</span>
          <highlight-code lang="javascript">
            <span>
                - (void)mediaCodecAPIUsage {
    NSString *path = [[NSBundle mainBundle] pathForResource:@"demofile" ofType:@"opus"];
    NSArray *paths = NSSearchPathForDirectoriesInDomains(NSDocumentDirectory, NSUserDomainMask, YES);
    NSString *documentsDirectory = [paths objectAtIndex:0];
    NSString *wavFilePath = [documentsDirectory stringByAppendingPathComponent:@"testDemo.wav"];

    // 同步调用 （会阻塞主线程）
    if ([[OrionSDK shared] decodeOPUSFile:path outputWAVPath:wavFilePath]) {
        [super addContent:[@"同步调用 " stringByAppendingString:wavFilePath]];
    }

    // 异步调用
    [[OrionSDK shared] decodeOPUSFile:path outputWAVPath:wavFilePath completion:^(NSError * _Nullable error) {
        [super addContent:[@"异步调用 " stringByAppendingString:wavFilePath]];
    }];
}
            </span>
    </highlight-code>
     <p></p>
  </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 30px;
    font-size: 16px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
    width: 100%;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-ios/access/Use.vue